import { SvgIcon } from '@mui/material';
import React from 'react';
import { ReactComponent as Svg } from './x.svg';

export const X = ()=>(
  <SvgIcon sx={{fillColor:'text.primary'}} viewBox='-2 -3 24 24'><Svg/></SvgIcon>
)
